import React, {useEffect} from 'react';
import Grid from "@mui/material/Grid";
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {useHistory, useParams} from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {initSliderForm, onSliderFormChange, selSliderForm} from "../../../stores/slider/slice";
import useValidation from "../../../validation/useValidation";
import {FormSliderInit, sliderValidations} from "../../../stores/slider/model";
import {createSlider, editSlider, getSliderById} from "../../../stores/slider/thunk";

export default function Slider() {

    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();
    const slider = useSelector(selSliderForm)

    const {errors, checkFiled, checkValidation} = useValidation({
        data: sliderValidations,
        key: 'sliderForm',
    });



    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onSliderFormChange({name, value}))
    }

    function putSlider(){
        const data = {
            title : slider.title,
            priority : slider.priority
        }
        dispatch(editSlider(id, data, backToSliders))
    }

    function addSlider(){
        const data = {
            title : slider.title,
            priority : slider.priority
        }
        dispatch(createSlider(data, backToSliders))
    }

    useEffect(()=>{
        id ?
            dispatch(getSliderById(id))
            :
            dispatch(initSliderForm(FormSliderInit))
        return ()=>{
            dispatch(initSliderForm(FormSliderInit))
        }
    },[])

    function backToSliders() {
        history.push('/sliders');
    }

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle={id ? "ویرایش اسلایدر" : "افزودن اسلایدر"}
                backBtnTitle="بازگشت"
                backBtnAction={backToSliders}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column divParentBasicInformation">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان'}
                                        variant="outlined"
                                        name={'title'}
                                        value={slider.title}
                                        error={errors.title}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'اولویت'}
                                        variant="outlined"
                                        name={'priority'}
                                        value={slider.priority}
                                        error={errors.priority}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putSlider : addSlider }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            {id ? "ویرایش" : "ایجاد"}
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
